import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalStorageServiceEncrypt } from 'angular-2-local-storage-encrypt';
import { city } from '../models/CitiesModel';
import { updateProfileModel } from '../models/updateProfileModel';
import { ValidationResponse } from '../models/validationResponse';
import { BaseService } from './base.service';
import { SettingService } from './setting.service';

@Injectable({
  providedIn: 'root'
})
export class UpdateProfileService  extends BaseService {

  apiUrl = '/api/Account';
  constructor(private httpClient: HttpClient,private _localStorageService:LocalStorageServiceEncrypt, private settingService:SettingService) {
    super();
  }

  // loadCities() {
  //   const CitiesFile = `assets/CitiesList/Cities.json`;
  //   return this.httpClient.get<city[]>( CitiesFile);
  //   }
    // loadCities(){
    //   return this.httpClient.get<city[]>(
    //     this.baseUrl +
    //       '/api/account/GetCitiesList' ,
    //     this.getAuthHeader()
    //   );
    // }
    getUserMobileNumber(): string {
      return localStorage.getItem('mobileNumber');
    }

    updateProfile(profile: updateProfileModel)
    {
      return this.httpClient.put<ValidationResponse>(
        this.baseUrl +
          this.apiUrl +'/UpdateProfile',profile,
        this.getAuthHeader()
      );
    }

    getProfileData() {
      return this.httpClient.get<updateProfileModel>(
        this.baseUrl +this.apiUrl+
          '/ProfileData',
        this.getAuthHeader()
      );
    }
}
